import React from 'react';
import {AlertDanger} from '@homeaway/react-alerts';

function ErrorViewComponent({clearAlert, error, errorTitle}) {
    return error ?
        <AlertDanger
            title={errorTitle}
            msg={error}
            svg="svg-alert-danger"
            dismissible
            closeText="Close"
            onAlertClosed={clearAlert}
        /> : null;
}

export default ErrorViewComponent;
